// Either limit alone misses a case: a log of short lines stays under the character
// cap, and one long unbroken paragraph stays under the line cap.
const MAX_CHARS = 5000;
const MAX_LINES = 100;

const LINE_BREAK = /\r\n|\r|\n/;

const isJson = (text: string) => {
  const trimmed = text.trim();
  if (!trimmed.startsWith('{') && !trimmed.startsWith('[')) return false;
  try {
    JSON.parse(trimmed);
    return true;
  } catch {
    return false;
  }
};

// Carries the text through `withName`, since renaming a File means building a new one.
class PastedTextFile extends File {
  readonly content: string;

  constructor(content: string, name: string, type: string) {
    super([content], name, { type });
    this.content = content;
  }

  withName(name: string) {
    return new PastedTextFile(this.content, name, this.type);
  }
}

export const countLines = (text: string) => text.split(LINE_BREAK).length;

export const shouldAttachPastedText = (text: string) => text.length > MAX_CHARS || countLines(text) > MAX_LINES;

export const isPastedText = (file: File): file is PastedTextFile => file instanceof PastedTextFile;

// A `.json` name tells Percy how to read the file, rather than guessing from the contents.
export const createPastedTextFile = (text: string) =>
  isJson(text)
    ? new PastedTextFile(text, 'pasted-text.json', 'application/json')
    : new PastedTextFile(text, 'pasted-text.txt', 'text/plain');
